<template lang="html">
  <div id="results-page-s1">

    <section class="placed-backg banner-section candidates">
      <div class="inside">
        <h1>Candidatos Disponibles</h1>
      </div>
    </section>

    <section class="container results-section">
      <div class="row">

        <!-- Columna izquierda con filtros -->
        <div class="col-lg-3 col-filters">
          <div class="bg-filters-mob" v-bind:class="{ active : isFiltersActive }" @click="isFiltersActive = false;"></div>

          <div class="filters-container" v-bind:class="{ active : isFiltersActive }">
            <div class="box-column-title">Personalizar búsqueda <a class="btn-close" @click="isFiltersActive = false;"><i class="fas fa-chevron-left"></i></a></div>

            <div class="main-box">

              <div class="box-filters-group">
                <h5 class="group-title">Busqueda</h5>

                <div class="box-options">
                  <b-form-group>
                    <b-form-input
                      v-model="form.keywords"
                      type="text"
                      placeholder="Nombre o apellidos"
                      required
                    ></b-form-input>
                  </b-form-group>

                  <div class="box-btn">
                    <b-button type="submit" class="btn-squ-1 lg">buscar</b-button>
                  </div>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Ubicación</h5>

                <div class="box-options">
                  <b-form-group label="Estado:" label-for="i-estado">
                    <b-form-select id="i-estado" v-model="form.estado" v-bind:class="{ empty : !form.estado }">
                      <b-form-select-option :value="null">Seleccionar Estado</b-form-select-option>
                      <b-form-select-option value="1">Jalisco</b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <!-- <div class="box-btn">
                    <b-button type="submit" class="btn-squ-1 lg">buscar</b-button>
                  </div> -->
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Área de Trabajo</h5>

                <div class="box-options">
                  <b-form-group label-for="i-estado">
                    <b-form-select id="i-estado" v-model="form.area" v-bind:class="{ empty : !form.area }">
                      <b-form-select-option :value="null">Seleccionar Área</b-form-select-option>
                      <b-form-select-option value="1">Cocina</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Nivel académico</h5>

                <div class="box-options">
                  <b-form-group v-slot="{ ariaSueldo }">
                    <b-form-checkbox-group class="checkbox-radio-group">
                      <b-form-radio v-model="form.nivel" :aria-describedby="ariaNivel" name="sueldo" value="0">Primaria - Secundaria</b-form-radio>
                      <b-form-radio v-model="form.nivel" :aria-describedby="ariaNivel" name="sueldo" value="1">Diplomado</b-form-radio>
                      <b-form-radio v-model="form.nivel" :aria-describedby="ariaNivel" name="sueldo" value="2">Licenciatura</b-form-radio>
                      <b-form-radio v-model="form.nivel" :aria-describedby="ariaNivel" name="sueldo" value="3">Posgrado</b-form-radio>
                      <b-form-radio v-model="form.nivel" :aria-describedby="ariaNivel" name="sueldo" value="4">Todos</b-form-radio>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Genero</h5>

                <div class="box-options">
                  <b-form-group v-slot="{ ariaSueldo }">
                    <b-form-checkbox-group class="checkbox-radio-group">
                      <b-form-radio v-model="form.genero" :aria-describedby="ariaGenero" name="sueldo" value="0">Masculino</b-form-radio>
                      <b-form-radio v-model="form.genero" :aria-describedby="ariaGenero" name="sueldo" value="1">Femenino</b-form-radio>
                      <b-form-radio v-model="form.genero" :aria-describedby="ariaGenero" name="sueldo" value="2">Indistinto</b-form-radio>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Publicado</h5>

                <div class="box-options">
                  <b-form-group v-slot="{ ariaPub }">
                    <b-form-checkbox-group class="checkbox-radio-group">
                      <b-form-radio v-model="form.publicado" :aria-describedby="ariaPub" name="publicado" value="0">Hace 1 hora</b-form-radio>
                      <b-form-radio v-model="form.publicado" :aria-describedby="ariaPub" name="publicado" value="1">Últimas 24 horas</b-form-radio>
                      <b-form-radio v-model="form.publicado" :aria-describedby="ariaPub" name="publicado" value="2">Últimos 7 días</b-form-radio>
                      <b-form-radio v-model="form.publicado" :aria-describedby="ariaPub" name="publicado" value="3">Últimos 14 días</b-form-radio>
                      <b-form-radio v-model="form.publicado" :aria-describedby="ariaPub" name="publicado" value="4">Último mes</b-form-radio>
                      <b-form-radio v-model="form.publicado" :aria-describedby="ariaPub" name="publicado" value="5">Más de un mes</b-form-radio>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!--  -->

        <!-- Columna derecha con resultados de empleos -->
        <div class="col-lg-9 col-results">
          <div class="row top-container">
            <div class="col-12 d-lg-none col-mobile-filter">
              <a class="btn-cur-1" @click="isFiltersActive = !isFiltersActive"><i class="fas fa-filter"></i> <span v-if="!isFiltersActive">Mostrar</span> <span v-if="isFiltersActive">Ocultar</span> filtros avanzados</a>
            </div>

            <div class="col-lg-6 col-count">
              <h4>{{candidates.length}} Candidatos encontrados</h4>
              <p>mostrados  1 - 10 en esta página</p>
            </div>

            <div class="col-lg-6 col-options">
              <div class="box">
                <span>ordenar por</span>
                <b-form-select v-model="form.order">
                  <b-form-select-option value="0">más recientes</b-form-select-option>
                  <b-form-select-option value="1">alfabeto</b-form-select-option>
                </b-form-select>
              </div>

              <div class="box">
                <span>resultados</span>
                <b-form-select v-model="form.perPage">
                  <b-form-select-option value="10">10 por página</b-form-select-option>
                  <b-form-select-option value="20">20 por página</b-form-select-option>
                </b-form-select>
              </div>
            </div>
          </div>

          <div class="row results-container">
            <div class="col-12 col-candidate-s1" v-for="(cand, hjbInx) in candidates" :key="'hjbInx-'+hjbInx">
              <div class="box">
                <div class="box-now" v-if="cand.now"><span>INMEDIATO</span></div>
                <div class="box-top" v-if="cand.best"></div>

                <div class="col col-photo">
                  <div class="img" v-bind:style="{ backgroundImage: 'url('+cand.img+')' }"></div>
                </div>

                <div class="col col-info">
                  <h4 class="name"><router-link target="_blank" to="">{{ cand.nombre }}</router-link></h4>
                  <h5>
                    <span class="career">{{ cand.career }}</span><br />
                    <i class="loc-icon"></i><span class="location">Guadalajara, Jalisco.</span>
                  </h5>
                </div>

                <div class="col-12 col-line">
                  <hr />
                </div>


                <div class="col col-buttons">
                  <a class="trans-250 btn-squ-1">guardar candidato</a>
                </div>
              </div>
            </div>
          </div>

          <div class="row pagination-container">
            <div class="col-12 col-pagination">
              <b-pagination
                v-model="form.currentPage"
                :total-rows="rows"
                :per-page="form.perPage"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </section>

  </div>
</template>

<script>
import searchFormComponent from '../shared/search-form-component.vue';
export default {
  data(){
    return{
      isFiltersActive: false,

      form: {
        order: 0,
        perPage: 10,
        currentPage: 1,

        estado: null,
        ciudad: null,
        area: null,
      },

      candidates: [
        { img: 'public/images/pages/users/profile-1.jpg', best: true, now: false, nombre: 'Karla Iñiguez Mora', career: 'Asesor de Ventas' },
        { img: 'public/images/pages/users/profile-2.jpg', best: false, now: true, nombre: 'Cesar Jiménez', career: 'Asesor de Ventas' },
        { img: 'public/images/pages/users/profile-3.jpg', best: false, now: false, nombre: 'Emmanuel Ruelas', career: 'Asesor de Ventas' },
        { img: 'public/images/pages/users/profile-1.jpg', best: true, now: true, nombre: 'Steffany Bosch', career: 'Lic. en Marketing Digital' },
        { img: 'public/images/pages/users/profile-4.jpg', best: false, now: false, nombre: 'Osvaldo Ruíz', career: 'Asesor de Ventas' },
        { img: 'public/images/pages/users/profile-5.jpg', best: false, now: true, nombre: 'Isabel Pardo', career: 'Lic. en Cominicación' },
        { img: 'public/images/pages/users/profile-6.jpg', best: true, now: false, nombre: 'Karla Iñiguez', career: 'Asesor de Ventas' },
        { img: 'https://th.bing.com/th/id/R.c2c095b67390b59eea0b12c7cb8cf0de?rik=RsLumfWdw%2blaig', best: false, now: false, nombre: 'Samuel L. Jackson', career: 'Medico Pedriata' },
      ],

      searchForm: {
        keywords: null,
        category: null,
        state: null,
      },
      pagination:{
        currentPage:0
      }

    }
  },

  computed: {
    rows() {
      return this.candidates.length
    }
  },

  methods:{
      serachVacancies(){
         axios.post(tools.url("/searchVacancies"),this.searchForm)
          .then((response)=>{
            this.candidates = response.data;
          }).catch((error)=>{
              alert('Ocurrio un error en la busqueda');
          });
      },
      getVacancies(){
          axios.get(tools.url("/vacanciesFront/"+this.pagination.currentPage))
          .then((response)=>{
            this.candidates = response.data;
          }).catch((error)=>{
              alert('Ocurrio un error en la busqueda');
          });
      }
  },

  mounted(){
    // if (this.$route.query.keywords) {
    //     this.searchForm.keywords = this.$route.query.keywords;
    //     this.searchForm.category = this.$route.query.category;
    //     this.searchForm.state = this.$route.query.state;
    //     this.serachVacancies();
    // }
    // else{
    //     this.getVacancies();
    // }
  },

  components: {
    searchFormComponent
  },
}
</script>
